import React, { useState, useEffect, useRef } from "react";
import { Table,  Tag, Skeleton } from "antd";
import styles from "./workflow.module.scss";
import { KoTitle } from "packages/typography";
import KoTag from "packages/tag";

const ReadOnlyWorkflowEditor = ({ data, onChange, readOnly, isDefault, height, setTemplateModal }) => {
  const [workflow, setWorkflow] = useState(data?.workflow || []);
  const tableRef = useRef(null);
  useEffect(() => {
    setWorkflow(data?.workflow || []);
  }, [data]);

  const handleTableChange = (newWorkflow) => {
    const updatedWorkflow = newWorkflow.map((status, index) => ({
      ...status,
      value: index + 1 // Update index value based on new order
    }));
    setWorkflow(updatedWorkflow);
    let template = data;
    template.workflow = updatedWorkflow;
    onChange && onChange(template);
  };

  const columns = [
    {
      title: "Key",
      dataIndex: "value",
      key: "value",
      width: 80,
      fixed: "left",
      editable: isDefault ? false : true,
      render: (text, record) => (
        <KoTag iscount={true} value={`KEY-${text}`} />
      )
    },
    {
      title: "Status",
      key: "preview",
      width: 100,
      editable: isDefault ? false : true,
      render: (_, record) => (
        <Tag style={{ background: record.background, color: record.color, padding: "3px 8px" , border:0}}>
          {record.label}
        </Tag>
      )
    },
    {
      title:  <Skeleton.Input active={false} size={'small'} block={'block'} />
      ,
      dataIndex: "label",
      key: "label",
      width: 200,
      fixed: "left",
      editable: isDefault ? false : true,
      render: (text, record) => (
        <Skeleton.Input active={false} size={'small'} block={'block'} />
      )
    },
    {
      title: <Skeleton.Input active={false} size={'small'} block={'block'} />,
      dataIndex: "background",
      key: "background",
      align: "center",
      width: 200,
      editable: isDefault ? false : true,
      render: (background, record) => (
        <Skeleton.Input active={false} size={'small'} block={'block'} />
      )
    },
   
    {
      title: <Skeleton.Input active={false} size={'small'} block={'block'} />,
      dataIndex: "nextStatuses",
      key: "nextStatuses",
      width: 200,
      editable: isDefault ? false : true,
      render: (nextStatuses, record) => (
        <Skeleton.Input  active={false} size={'small'} block={'block'} />
      )
    }
    
  ];

  return (
    <div className={`${styles.wrapper}`}>
      {!isDefault && <div className={styles.header}>
        <KoTitle text={data?.name || "Workflow Template"} level={5} />
      </div>}
      <Table
        dataSource={workflow?.filter(status => status.label.trim() !== "")} // Filter out empty rows
        pagination={false}
        ref={tableRef}
        columns={columns}
        size="small"
        scroll={{
          x: 'max-content',
          y: 'calc(100vh - 50rem)'
        }}
        rowKey="value"
        onChange={(pagination, filters, sorter, extra) => handleTableChange(extra.currentDataSource)}
      />
    </div>
  );
};

export default ReadOnlyWorkflowEditor;
